var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.gameListData.length > 0)?_c('ul',{staticClass:"list listGame"},_vm._l((_vm.gameListData),function(item,index){return _c('li',{key:index},[_c('a',{staticClass:"item",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.fnPlayGame({
        url: item.play_url,
        orientation:item.orientation,
        downloadurl:item.downloadurl,
        coreType: item.core_type,
        gameType: item.game_type,
        gameCode: item.game_code,
        gameName: item.game_name,
        serverName: item.server_name,
        serverId: item.server_id,
        idx: index + 1,
        page_block_id: 7,
        launch:item.launch || ''})}}},[_c('div',{staticClass:"top"},[_c('div',{staticClass:"img"},[_c('img',{attrs:{"src":item.logo_small,"alt":""}})]),_c('div',{staticClass:"txt"},[_c('div',{staticClass:"gameName",domProps:{"textContent":_vm._s(item.game_name)}}),_c('div',{staticClass:"gameTag",domProps:{"textContent":_vm._s(item.model_name)}}),_c('span',{staticClass:"btnPlayGame"},[_vm._v("进入游戏")])])]),_c('div',{staticClass:"btm"},[_vm._v(_vm._s(item.tips))])])])}),0):_c('div',{staticClass:"listEmpty"},[_c('empty-data',[_vm._v("暂无数据，请稍候再试")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }